import { computed } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useMCampaignStore } from "@stores/mCampaign";
import { useMCampaignTargetsStore } from "@stores/mCampaignTargets";
import { useMCampaignQuotasStore } from "@stores/mCampaignQuotas";
import { useCCampaignsStore } from "@stores/cCampaigns";
import { useCAdsetsStore } from "@stores/cAdsets";

/**
 * Single source of truth for "does the current master-campaign page have unsaved changes?".
 * Consumed by both the header Save button (canSaveMCampaign in AppHeaderActions) and the
 * leave-confirmation guard (useUnsavedChangesGuard) so the two can never drift.
 */
export function useMCampaignUnsavedChanges() {
  const route = useRoute();

  const { hasMCampaignChanged, hasMCampaignActionsChanged } = storeToRefs(useMCampaignStore());
  const { hasTargetsChanged } = storeToRefs(useMCampaignTargetsStore());
  const { hasQuotasChanged } = storeToRefs(useMCampaignQuotasStore());
  const { hasCCampaignsChanged } = storeToRefs(useCCampaignsStore());
  const { hasCAdsetsChanged } = storeToRefs(useCAdsetsStore());

  const hasUnsavedChanges = computed(() => {
    switch (route.name) {
      case "CampaignTargets":
      case "CampaignQuotas":
        return hasTargetsChanged.value || hasQuotasChanged.value;
      case "MCampaignBudgets":
        return hasCAdsetsChanged.value || hasCCampaignsChanged.value || hasMCampaignChanged.value;
      case "MCampaignActions":
        return hasMCampaignActionsChanged.value;
      default:
        return hasMCampaignChanged.value;
    }
  });

  return { hasUnsavedChanges };
}
